module.exports = __webpack_public_path__ + "static/brazier_of_commanding_fire_elementals-daf444f9fbfc1d1ecdf4fabd316b30c4.jpeg";